"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gbCountry = void 0;
var _companyNumber = require("../../companyNumber");
// i18next-extract-mark-ns-start Countries

var gbCountry = exports.gbCountry = function gbCountry(t) {
  return {
    id: 'UK',
    name: t('United Kingdom'),
    flag: '🇬🇧',
    zipcodeChecker: function zipcodeChecker(zipcode) {
      var regex = /^[A-Z]{1,2}[0-9][0-9A-Z]?\s?[0-9][A-Z]{2}$/;
      return regex.test(zipcode);
    },
    zipcodePlaceholder: 'e.g. SW1A 1AA or SW1W 0NY',
    zipcodeMatcher: function zipcodeMatcher(zipCode, subZoneZipcode) {
      return zipCode.startsWith(subZoneZipcode);
    },
    phonePrefix: '44',
    phoneLength: 10,
    zipcodeHasLetters: true,
    pricingVersion: 14,
    timezone: 'Europe/London',
    currency: 'GBP',
    companyNumber: {
      label: _companyNumber.labels.UK,
      checker: _companyNumber.checkers.UK,
      placeholder: '01967717'
    }
  };
};